import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import paths from '@paths';
import api from '@api';
import utils from '@utils';
import constants from '@constants';
import resources from '@resources';

export const submit = async (value: any, actions: FormikHelpers<any>) => {
  try {
    // 1. CognitoUserを取得 (SNSプロバイダー取得の為)
    const user = await utils.amplify.getUser();

    // 2. 新規チーム作成
    const newTeam = await api.teams.create();

    const birthdate = resources.users.getBirthDate(
      value.birthyear,
      value.birthmonth,
      value.birthday
    );

    // 3. 特権管理者作成
    const b: UserCreateBody = {
      teamId: newTeam.id,
      sub: user.attributes.sub,
      cognitoUserName:
        user.signInUserSession.idToken.payload['cognito:username'],
      lastName: value.lastName,
      firstName: value.firstName,
      lastKana: value.lastKana,
      firstKana: value.firstKana,
      prefecture: value.prefecture,
      email: user.attributes.email,
      phoneNumber: value.phoneNumber,
      isEnabled: true,
      provider: JSON.parse(user.attributes.identities)[0].providerName,
      authLevel: constants.AUTHORITIES.SUPER_ADMIN,
      organization: value.organization,
      position: value.position,
      gender: value.gender,
      birthdate,
    };

    await api.users.create(b);

    window.location.assign(paths.dashboard.main);
  } catch (error) {
    switch (error.response.data.message) {
      case 'email is not unique': {
        notify(constants.ERRORS.EXISTED_EMAIL, 'error');
        break;
      }
      default: {
        notify('新規登録に失敗しました', 'error');
      }
    }
  } finally {
    actions.setSubmitting(false);
  }
};
